module.exports = __webpack_public_path__ + "static/media/Inter-Bold.00189378.woff";